export default "__VITE_ASSET__BaQSYarB__"